import { z } from 'zod';
import { ProfileAvatarDesign } from '../members/avatar.js';
import { ProfileContactSummary, ProfileLink, ProfileLocale, ProfilePreferences, ProfileRendered, ProfileTheme, } from '../members/profile.js';
export const MobileNativeStatus = z.enum([
    'native_complete',
    'native_partial',
    'web_fallback',
    'blocked_by_api',
]);
export const MobileDestination = z.enum([
    'today',
    'read',
    'create',
    'time',
    'spaces',
    'me',
    'forum',
    'surveys',
    'scheduling',
    'coordination',
    'files',
    'bookmarks',
    'notifications',
    'members',
    'parent',
    'admin',
    'newsletter',
]);
export const MobileViewer = z.object({
    id: z.string().uuid(),
    displayName: z.string().min(1),
    role: z.string().min(1),
    locale: z.enum(['zh', 'en']),
    username: z.string().nullable(),
    email: z.string().email().nullable(),
    phone: z.string().nullable(),
    emailVerifiedAt: z.string().datetime({ offset: true }).nullable(),
    phoneVerifiedAt: z.string().datetime({ offset: true }).nullable(),
});
export const MobileProfileSummary = z.object({
    userId: z.string().uuid(),
    displayName: z.string().min(1),
    preferredLocale: ProfileLocale,
    rendered: ProfileRendered,
    contact: ProfileContactSummary,
    interests: z.array(z.string().min(1).max(40)).max(16),
    links: z.array(ProfileLink).max(8),
    avatar: ProfileAvatarDesign,
    theme: ProfileTheme,
    preferences: ProfilePreferences,
    profileUrl: z.string().min(1),
    editUrl: z.string().min(1),
    updatedAt: z.string().datetime({ offset: true }).nullable(),
});
export const MobileGroupSummary = z.object({
    id: z.string().uuid(),
    slug: z.string().min(1),
    name: z.string().min(1),
    color: z.string().min(1),
    icon: z.string().min(1),
    viewerRole: z.string().nullable(),
});
export const MobileUnreadCounts = z.object({
    notifications: z.number().int().nonnegative(),
    required: z.number().int().nonnegative(),
    mentions: z.number().int().nonnegative(),
    dueSoon: z.number().int().nonnegative(),
});
export const MobileCapability = z.object({
    key: z.string().min(1),
    enabled: z.boolean(),
    nativeStatus: MobileNativeStatus,
    reason: z.string().nullable(),
});
export const MobileBootstrapResponse = z.object({
    serverTime: z.string().datetime({ offset: true }),
    viewer: MobileViewer.nullable(),
    profile: MobileProfileSummary.nullable(),
    activeGroup: MobileGroupSummary.nullable(),
    unreadCounts: MobileUnreadCounts,
    capabilities: z.array(MobileCapability),
    primaryTabs: z.array(MobileDestination),
    sidebarDestinations: z.array(MobileDestination),
});
export const MobileTodayItemKind = z.enum([
    'article',
    'calendar',
    'survey',
    'file',
    'forum',
    'notification',
    'group',
    'profile',
    'create',
]);
export const MobileTodayPriority = z.enum(['normal', 'due_soon', 'required']);
export const MobileTodayItem = z.object({
    id: z.string().min(1),
    kind: MobileTodayItemKind,
    title: z.string().min(1),
    subtitle: z.string(),
    badge: z.string().nullable(),
    url: z.string().min(1),
    dueAt: z.string().datetime({ offset: true }).nullable(),
    priority: MobileTodayPriority,
});
export const MobileTodayResponse = z.object({
    serverTime: z.string().datetime({ offset: true }),
    greeting: z.string().min(1),
    nextAction: MobileTodayItem.nullable(),
    timeline: z.array(MobileTodayItem),
    continueReading: z.array(MobileTodayItem),
    recentActivity: z.array(MobileTodayItem),
});
export const MobileCreateOption = z.object({
    id: z.string().min(1),
    kind: z.string().min(1),
    title: z.string().min(1),
    subtitle: z.string(),
    destination: MobileDestination,
    url: z.string().min(1),
    nativeStatus: MobileNativeStatus,
    enabled: z.boolean(),
    disabledReason: z.string().nullable(),
});
export const MobileCreateOptionsResponse = z.object({
    serverTime: z.string().datetime({ offset: true }),
    options: z.array(MobileCreateOption),
});
//# sourceMappingURL=mobile.js.map